export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  author: string;
  cover: string;
  summary: string;
  content: string[];
}

export const newsList: NewsItem[] = [
  {
    id: 'n1',
    title: '《时间的皱褶》口碑持续走高，澄一角引发观众热议',
    date: '2023-11-18',
    category: '作品动态',
    author: '影视观察',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20news%20image%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20accent%2C%20abstract%20clockwork%20gears%20and%20soft%20bokeh%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20film%20magazine%20photography%20with%20elegant%20lighting&width=800&height=500&seq=news-01&orientation=landscape',
    summary:
      '新片《时间的皱褶》上映后收获良好口碑，吉泽明步饰演的钟表修复师澄被认为是一次突破性的表演。',
    content: [
      '由中村凉介执导、吉泽明步主演的电影《时间的皱褶》自上映以来，凭借精巧的叙事结构与细腻的表演获得观众与评论界的广泛关注。影片以钟表修复师这一冷门职业为切口，讲述了一个关于时间与选择的故事。',
      '不少观众表示，吉泽明步在片中大量依靠眼神与细微动作完成情绪表达，把澄这个角色的克制与执拗诠释得恰到好处。有评论认为，这是她近年来最具层次感的一次表演。',
      '片方透露，影片的修复工序场景均在顾问指导下真实还原，主演还为角色专门学习了基础的机芯拆装。影片目前仍在各大院线热映。',
    ],
  },
  {
    id: 'n2',
    title: '《沉默的证明》收官，现实题材表达获行业认可',
    date: '2023-09-02',
    category: '作品动态',
    author: '剧集前沿',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20news%20image%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20lamp%20glow%2C%20dim%20interview%20room%20ambience%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20film%20magazine%20photography%20with%20elegant%20lighting&width=800&height=500&seq=news-02&orientation=landscape',
    summary:
      '悬疑律政剧《沉默的证明》正式收官，扎实的推理与对现实议题的关照让该剧成为同期讨论度最高的作品之一。',
    content: [
      '《沉默的证明》以检察官美咲重审旧案为主线，用一环扣一环的推理推动剧情。剧集在保持类型爽感的同时，也把镜头对准了证据链条背后的现实困境。',
      '吉泽明步饰演的美咲被观众形容为「冷静但有温度」。她在剧中克制的表演方式，与整部剧集严谨的基调形成了良好的呼应。',
      '制作方表示，剧本筹备历时两年，团队走访了多位一线从业者，力求在细节上经得起推敲。该剧的讨论热度在收官周达到顶峰。',
    ],
  },
  {
    id: 'n3',
    title: '回顾《遥远的星空》：一部关于孤独与信念的作品',
    date: '2023-07-21',
    category: '深度解读',
    author: '影评人·林野',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20news%20image%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20starlight%2C%20observatory%20dome%20under%20a%20vast%20starfield%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20film%20magazine%20photography%20with%20elegant%20lighting&width=800&height=500&seq=news-03&orientation=landscape',
    summary:
      '时隔一年重看《遥远的星空》，这部作品对科学、孤独与信念的描摹依然令人动容。',
    content: [
      '《遥远的星空》上映于 2022 年，讲述天文学者凛在山顶天文台执着搜寻一颗恒星的故事。影片没有宏大的特效场面，却用大量静默的镜头把观众带进了那种近乎固执的专注里。',
      '吉泽明步的表演在这个角色上显得格外内敛。她把一位学者的偏执与柔软藏在一次次望向天窗的动作里，让「信念」这个抽象的词有了具体的重量。',
      '影片的摄影同样值得一提：夜空、仪器与呼吸声构成了独特的视听节奏。它提醒我们，有些坚持注定要独自完成。',
    ],
  },
  {
    id: 'n4',
    title: '吉泽明步谈角色塑造：把情绪藏在动作里',
    date: '2023-05-14',
    category: '人物专访',
    author: '本刊编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20news%20image%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20rim%20light%2C%20calm%20studio%20interview%20setting%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20film%20magazine%20photography%20with%20elegant%20lighting&width=800&height=500&seq=news-04&orientation=landscape',
    summary:
      '在最新一期专访中，吉泽明步分享了她对表演节奏的理解，以及如何用身体语言替代台词。',
    content: [
      '谈到近年偏爱的表演方式，吉泽明步说自己越来越在意「不说出来的部分」。她习惯先为角色设计一套动作逻辑，再让情绪从动作里自然生长出来。',
      '在准备《记忆之匙》时，她花了很长时间观察心理咨询师的工作状态，记录下那些微小的停顿与呼吸。她说，这些细节最终都变成了角色的底色。',
      '对于剧本选择，她坦言更在意故事是否真诚，而不是题材是否热门。她希望每一个角色都能留下一点值得回味的东西。',
    ],
  },
  {
    id: 'n5',
    title: '《白色记事簿》重映：医疗剧里的真实质感',
    date: '2023-03-08',
    category: '深度解读',
    author: '剧集前沿',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20news%20image%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20corridor%20light%2C%20quiet%20hospital%20hallway%20at%20night%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20film%20magazine%20photography%20with%20elegant%20lighting&width=800&height=500&seq=news-05&orientation=landscape',
    summary:
      '医疗剧《白色记事簿》迎来重映，其对急诊科的写实呈现至今仍被观众反复提及。',
    content: [
      '《白色记事簿》以急诊科为舞台，用十二集的篇幅记录了一位年轻医生的成长。剧集对医疗流程与医患关系的呈现，被不少从业者评价为「难得地克制而准确」。',
      '吉泽明步饰演的急诊医生千夏，在高压环境下逐渐学会与疲惫共处。角色的弧光是整部剧最动人的部分之一。',
      '本次重映新增了部分幕后花絮，让观众得以了解剧组为还原真实急诊场景所做的准备。',
    ],
  },
  {
    id: 'n6',
    title: '新项目官宣：吉泽明步加盟都市群像剧《城市之光》',
    date: '2022-12-10',
    category: '官方公告',
    author: '官方发布',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20news%20image%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20skyline%20lights%2C%20city%20skyline%20at%20dusk%20with%20cranes%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20film%20magazine%20photography%20with%20elegant%20lighting&width=800&height=500&seq=news-06&orientation=landscape',
    summary:
      '官方正式公布新剧《城市之光》的主演阵容，吉泽明步将出演建筑设计师结衣。',
    content: [
      '官方于今日公布都市群像剧《城市之光》的主创阵容，吉泽明步确认出演建筑设计师结衣一角。该剧将围绕老城区改造展开，描绘一群城市建设者的日常。',
      '主创团队表示，选择吉泽明步出演结衣，是因为看重她能够准确表现角色在理想与现实之间的摇摆。剧集目前已进入筹备阶段。',
      '更多拍摄花絮与播出信息，将在后续陆续公布。',
    ],
  },
  {
    id: 'n7',
    title: '从《逆光之夏》到《深海回声》：影像风格的两次转向',
    date: '2022-09-27',
    category: '深度解读',
    author: '影评人·林野',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20news%20image%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20horizon%20glow%2C%20abstract%20ocean%20depth%20with%20soft%20particles%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20film%20magazine%20photography%20with%20elegant%20lighting&width=800&height=500&seq=news-07&orientation=landscape',
    summary:
      '对比两部代表作，可以看到吉泽明步在银幕形象上的两次明显转向。',
    content: [
      '《逆光之夏》里的佐仓绫温暖而贴近生活，《深海回声》中的南云则冷静而疏离。两部作品虽然题材迥异，却共同勾勒出一位演员不断拓展边界的过程。',
      '有评论指出，吉泽明步在处理两种截然不同的气质时，把握住了各自的分寸，没有让表演沦为单一的符号。',
      '从治愈到悬疑，她的作品序列呈现出丰富的层次，这也是她始终保有关注度的原因之一。',
    ],
  },
  {
    id: 'n8',
    title: '《夜幕下的她》入选年度亚洲影展展映单元',
    date: '2022-06-15',
    category: '官方公告',
    author: '官方发布',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20news%20image%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20street%20lamp%20light%2C%20night%20city%20alley%20with%20soft%20reflections%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20film%20magazine%20photography%20with%20elegant%20lighting&width=800&height=500&seq=news-08&orientation=landscape',
    summary:
      '《夜幕下的她》确认入选年度亚洲影展展映单元，将在影展期间进行专场放映。',
    content: [
      '《夜幕下的她》讲述记者沙罗追踪匿名线索的调查故事，以冷峻的影像风格受到关注。影片确认入选年度亚洲影展展映单元。',
      '影展方评价该片「在类型叙事与人物刻画之间找到了平衡」。届时主创将出席映后交流环节。',
      '影片此前已在本土市场收获良好反响，此次展映有望让更多观众看到它。',
    ],
  },
  {
    id: 'n9',
    title: '《第七封信》上映三周年，观众自发起「重看计划」',
    date: '2023-02-19',
    category: '粉丝互动',
    author: '本站编辑',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20news%20image%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20desk%20lamp%20light%2C%20handwritten%20letters%20stacked%20on%20a%20desk%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20film%20magazine%20photography%20with%20elegant%20lighting&width=800&height=500&seq=news-09&orientation=landscape',
    summary:
      '《第七封信》迎来上映三周年，众多影迷在社交平台发起重温活动，分享作品带来的感动。',
    content: [
      '《第七封信》上映三周年之际，不少影迷发起「重看计划」，用自己的方式纪念这部以书信为线索的作品。',
      '图书编辑奈月这一角色被许多观众视为「最贴近日常的浪漫」。影片对时间与约定的处理，成为讨论的焦点。',
      '本站整理了部分影迷留言与作品幕后资料，供大家回顾。',
    ],
  },
  {
    id: 'n10',
    title: '吉泽明步作品年表整理（2015—2023）现已上线',
    date: '2023-12-05',
    category: '站点更新',
    author: '本站编辑',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20news%20image%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20accent%2C%20abstract%20film%20strip%20and%20archive%20folders%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20film%20magazine%20photography%20with%20elegant%20lighting&width=800&height=500&seq=news-10&orientation=landscape',
    summary:
      '本站新增作品年表功能，可按年份、类型、角色类型快速检索全部作品。',
    content: [
      '为了方便影迷系统了解作品脉络，本站新增作品年表整理功能。你可以在「作品」页面按类型、年份与角色类型进行筛选，并切换按时间、热度或名称排序。',
      '年表收录了 2015 年至 2023 年间公开的作品条目，并附有简介与角色说明。后续新作将持续补充。',
      '欢迎通过「关于本站」页面的联系方式向我们提交纠错与补充建议。',
    ],
  },
];